import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';

import { StepsCard } from '@savebetter/components';

import { LogoHeightType } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Card extends SbBlokData {
  title: string;
  description: string;
}

export interface GatsbyImageProps {
  img: ImageDataLike;
  alt: string;
  mobile?: LogoHeightType;
  tablet?: LogoHeightType;
  desktop?: LogoHeightType;
}

interface Blok extends PageSectionBlok {
  title: string;
  media?: GatsbyImageProps[];
  cards: Card[];
}

interface HowItWorksProps extends PageSectionProps {
  blok: Blok;
}

export const HowItWorks: FunctionComponent<React.PropsWithChildren<HowItWorksProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, cards = [], media = [], hasPaddingBottom, hasPaddingTop } = blok;
  const image = getImage(media[0]?.img);
  return (
    <Section
      width="sm"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader>{title}</PageSectionHeader>
      <div className="w-full flex flex-col justify-center">
        {media.length > 0 && image && <GatsbyImage alt={media[0].alt} className="w-full" image={image} />}
      </div>

      <ol className="list-none">
        {cards.map((card, index) => {
          const { _uid, title, description } = card;

          return (
            <StepsCard
              {...storyblokEditable(card)}
              key={_uid}
              title={title}
              description={description}
              stepNumber={index + 1}
              className="mt-6 lg:mt-8"
            />
          );
        })}
      </ol>
    </Section>
  );
};
